"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _components = require("../components");
var _ChipFilter = _interopRequireDefault(require("./ChipFilter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ChipsFilter(_ref) {
  var query = _ref.query,
    filters = _ref.filters;
  var history = (0, _reactRouter.useHistory)();
  var location = (0, _reactRouter.useLocation)();
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  (0, _react.useEffect)(function () {
    setData(function () {
      var updated = {};
      filters.forEach(function (filter) {
        var value = query.get(filter.name);
        if (value !== null && value !== '') {
          updated = Object.assign(Object.assign({}, updated), _defineProperty({}, filter.name, value));
        }
      });
      return updated;
    });
  }, [filters, query]);
  var updateSearch = (0, _react.useCallback)(function (data, query) {
    history.push({
      pathname: location.pathname,
      state: location.state,
      search: query.toString()
    });
    setData(data);
  }, [history, location]);
  var onUpdate = (0, _react.useCallback)(function (name, info) {
    var updated = data;
    if (info[name] === undefined) {
      delete updated[name];
      query["delete"](name);
    } else {
      Object.keys(info).forEach(function (key) {
        query.set(key, info[key]);
      });
      updated = Object.assign(Object.assign({}, updated), info);
    }
    updateSearch(updated, query);
  }, [data, updateSearch, query]);
  var clearFilters = (0, _react.useCallback)(function () {
    filters.forEach(function (filter) {
      query["delete"](filter.name);
    });
    updateSearch({}, query);
  }, [filters, query, updateSearch]);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    sx: {
      px: 2,
      py: 0,
      mb: 1.5
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 1
  }, filters.map(function (filter) {
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      key: filter.name,
      item: true,
      xs: "auto"
    }, /*#__PURE__*/_react["default"].createElement(_ChipFilter["default"], Object.assign({
      value: data[filter.name],
      onUpdate: onUpdate
    }, filter)));
  }))), Object.keys(data).length > 0 && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    variant: "text",
    color: "secondary",
    size: "small",
    startIcon: /*#__PURE__*/_react["default"].createElement(_components.ClearFilterIcon, null),
    onClick: clearFilters
  }, (0, _core.translate)('filters.clear')))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ChipsFilter);